import React from 'react';
import { Quote, Star } from 'lucide-react';
import { testimonials } from '../mock';

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative py-24 lg:py-32 bg-white border-y border-[#e8e4d8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <p className="text-xs uppercase tracking-[0.3em] text-[#ea580c] mb-4 font-semibold">Real results</p>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-[#0b0f0d] leading-tight">
            Contractors don’t care about awards. They care about jobs.
          </h2>
          <p className="mt-5 text-[#4a4f4c] text-lg">
            Here’s what happens when local trade companies turn their marketing over to Mercury.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <div key={i} className="rounded-2xl border border-[#e8e4d8] bg-[#faf9f5] p-7 hover:border-[#0b0f0d]/25 hover:bg-white flex flex-col">
              <Quote className="text-[#ea580c]" size={26} />
              <p className="mt-4 text-[#0b0f0d] leading-relaxed text-[15px] flex-1">“{t.quote}”</p>
              <div className="mt-6 pt-5 border-t border-[#e8e4d8] flex items-center justify-between">
                <div>
                  <div className="font-semibold text-[#0b0f0d]">{t.name}</div>
                  <div className="text-xs text-[#6b6f6c]">{t.company}</div>
                </div>
                <div className="text-right">
                  <div className="flex justify-end mb-1">
                    {[...Array(5)].map((_, k) => (
                      <Star key={k} size={11} className="fill-[#ea580c] text-[#ea580c]" />
                    ))}
                  </div>
                  <div className="text-[#ea580c] text-xs font-semibold">{t.metric}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
